/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/{-id}/signature
 */
export interface SignatureRequestBuilder extends BaseRequestBuilder<SignatureRequestBuilder> {
    /**
     * Streams the PNG of the signature covering the order's batch (every order of an agency's placement carries the same one). 404 when the order has none.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<SignatureRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * Streams the PNG of the signature covering the order's batch (every order of an agency's placement carries the same one). 404 when the order has none.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SignatureRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Streams the PNG of the signature covering the order's batch (every order of an agency's placement carries the same one). 404 when the order has none.
 */
export interface SignatureRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const SignatureRequestBuilderUriTemplate = "{+baseurl}/api/orders/{%2Did}/signature{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const SignatureRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SignatureRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
